import React, { Component, PropTypes } from 'react';
import { Toggle } from 'material-ui';
class InterconnectingRooms extends Component {
  
  toggleValue = (field) => {
    this.props._saveField({
      updateField: field,
      updateBody: !this.props.profileToShow[field],
    });
  };

  render() {
    const { profileToShow, roomIsEditable } = this.props;
    const isInterconnecting = profileToShow.interconnectingRooms;
    const label = isInterconnecting ? 'Interconnecting Rooms Available' : 'No Interconnecting Rooms Available';
    const toggleOrDisplay = (() => {
      if (roomIsEditable) {
        return (
          <Toggle
            checked={isInterconnecting}
            style = {{
              cursor: 'pointer',
              overflow: 'visible',
              width: '100%',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
            onToggle={this.toggleValue.bind(this, 'interconnectingRooms')}
            name="toggleName1"
            labelPosition="right"
            label={label}
            value="toggleValue1"
          />
        );
      }
      return (
        <span
          style={{
            fontSize: '14px',
            color: 'rgba(0, 0, 0, 0.541176)',
          }}
        >
          {label}
        </span>
      );
    })();

    return (
      <div style={{ marginTop: '32px', height: '48px' }}>
        {toggleOrDisplay}
      </div>
    );
  }
}


InterconnectingRooms.propTypes = {
  _saveField: PropTypes.func,
  profileToShow: PropTypes.object,
  editField: PropTypes.func,
  roomIsEditable: PropTypes.bool,
};

export default InterconnectingRooms;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/interconnecting-rooms.jsx